import BasePresenter from "../../redare/presenter/BasePresenter";
import * as UserHttp from "../http/UserHttp";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

export default class UserPresenter extends BasePresenter {

    /**
     * @param body: {key, roleId, orgId, orgName, userIds, orgParentId, orgParentName, namePinyinInitials, namePinyinShort, staffName, staffId, mobileFlag, emailFlag, mobile, email, name, id, account, key, platform, userPlatform, menuId, needResetPwd, roleIds, status, incMenu, incRole, incRoot, incPwd}
     * @param query: {curPage,pageSize}
     * @returns Promise
     */
    findUserPage(body, query, success, fails) {

        if (this._onBeforeFindUserPage) {
            let data = this._onBeforeFindUserPage(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserHttp.findUserPage(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindUserPageSuccess) {
                    result = this._onBeforeFindUserPageSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindUserPageSuccess) {
                    this.view._onFindUserPageSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {name, mobile, email, photo, account, pwd, platform, userPlatform, menuId, roleIds, needResetPwd}
     * @param query: {}
     * @returns Promise
     */
    addUser(body, query, success, fails) {

        if (this._onBeforeAddUser) {
            let data = this._onBeforeAddUser(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserHttp.addUser(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeAddUserSuccess) {
                    result = this._onBeforeAddUserSuccess(result, {body, query});
                }

                if (this.view && this.view._onAddUserSuccess) {
                    this.view._onAddUserSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {accountId, account, platform, userPlatform}
     * @param query: {}
     * @returns Promise
     */
    delUser(body, query, success, fails) {

        if (this._onBeforeDelUser) {
            let data = this._onBeforeDelUser(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserHttp.delUser(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeDelUserSuccess) {
                    result = this._onBeforeDelUserSuccess(result, {body, query});
                }

                if (this.view && this.view._onDelUserSuccess) {
                    this.view._onDelUserSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {account, name, mobile, email, photo, where}
     * @param query: {}
     * @returns Promise
     */
    modifyUser(body, query, success, fails) {

        if (this._onBeforeModifyUser) {
            let data = this._onBeforeModifyUser(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserHttp.modifyUser(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeModifyUserSuccess) {
                    result = this._onBeforeModifyUserSuccess(result, {body, query});
                }

                if (this.view && this.view._onModifyUserSuccess) {
                    this.view._onModifyUserSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {accountId, platform, userPlatform, pwd, needResetPwd}
     * @param query: {}
     * @returns Promise
     */
    modifyPwd(body, query, success, fails) {

        if (this._onBeforeModifyPwd) {
            let data = this._onBeforeModifyPwd(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserHttp.modifyPwd(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeModifyPwdSuccess) {
                    result = this._onBeforeModifyPwdSuccess(result, {body, query});
                }

                if (this.view && this.view._onModifyPwdSuccess) {
                    this.view._onModifyPwdSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {key, roleId, orgId, orgName, userIds, orgParentId, orgParentName, namePinyinInitials, namePinyinShort, staffName, staffId, mobileFlag, emailFlag, mobile, email, name, id, account, key, platform, userPlatform, menuId, needResetPwd, roleIds, status, incMenu, incRole, incRoot, incPwd}
     * @param query: {}
     * @returns Promise
     */
    findUserList(body, query, success, fails) {

        if (this._onBeforeFindUserList) {
            let data = this._onBeforeFindUserList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserHttp.findUserList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindUserListSuccess) {
                    result = this._onBeforeFindUserListSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindUserListSuccess) {
                    this.view._onFindUserListSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {accountId, roleIds, platform, userPlatform, replace}
     * @param query: {}
     * @returns Promise
     */
    updateUserRole(body, query, success, fails) {

        if (this._onBeforeUpdateUserRole) {
            let data = this._onBeforeUpdateUserRole(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserHttp.updateUserRole(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeUpdateUserRoleSuccess) {
                    result = this._onBeforeUpdateUserRoleSuccess(result, {body, query});
                }

                if (this.view && this.view._onUpdateUserRoleSuccess) {
                    this.view._onUpdateUserRoleSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {}
     * @returns Promise
     */
    getCurrentUser(body, success, fails) {

        if (this._onBeforeGetCurrentUser) {
            let data = this._onBeforeGetCurrentUser(body);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
        }

        UserHttp.getCurrentUser(body).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeGetCurrentUserSuccess) {
                    result = this._onBeforeGetCurrentUserSuccess(result, {body});
                }

                if (this.view && this.view._onGetCurrentUserSuccess) {
                    this.view._onGetCurrentUserSuccess(result, {body});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {mobile, name, orgId, id, account, userPlatform, platform, status, incMenu, incPwd}
     * @param query: {}
     * @returns Promise
     */
    getUser(body, query, success, fails) {

        if (this._onBeforeGetUser) {
            let data = this._onBeforeGetUser(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserHttp.getUser(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeGetUserSuccess) {
                    result = this._onBeforeGetUserSuccess(result, {body, query});
                }

                if (this.view && this.view._onGetUserSuccess) {
                    this.view._onGetUserSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {}
     * @returns Promise
     */
    syncSysUser(body, success, fails) {

        if (this._onBeforeSyncSysUser) {
            let data = this._onBeforeSyncSysUser(body);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
        }

        UserHttp.syncSysUser(body).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeSyncSysUserSuccess) {
                    result = this._onBeforeSyncSysUserSuccess(result, {body});
                }

                if (this.view && this.view._onSyncSysUserSuccess) {
                    this.view._onSyncSysUserSuccess(result, {body});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

}